import React, { useState, useEffect } from 'react';
import { Fab, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import '../styles/css/ScrollToTop.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Set mounted state after initial render to ensure we're in browser environment
  useEffect(() => {
    setMounted(true);
  }, []);

  // Show button when page is scrolled down
  useEffect(() => {
    if (!mounted) return;
    
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Only add the listener if we're mounted and in browser
    window.addEventListener('scroll', toggleVisibility);
    
    // Check initial visibility
    toggleVisibility();
    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [mounted]);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Don't render anything during initial mount
  if (!mounted) return null;

  return (
    <Zoom in={isVisible}>
      <Fab 
        color="secondary" 
        size="medium" 
        aria-label="scroll back to top" 
        className="scroll-to-top"
        onClick={scrollToTop}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};

export default ScrollToTop;
